import Grid from "@mui/material/Grid";

import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox.jsx";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpRadioButton,
} from "../../../Component/Common/ToolBox/ToolBox.js";

export default function WmsHead({
  fLocation_MultiSelect,
  sLocationData,

  //multiselect
  sWebStockReportData,
  sWebStockReportArr,

  HeadObject,
  fLocation,
  
  sWebBetweenReportArr,
  fReportType,
}) {
  return (
    <form id="BinWiseCBMRreportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center"
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"BinWise CBM Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            {/* <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName={"sLocation"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid> */}
            <Grid item xs={9} sm={9} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"02"}
                options={sLocationData}
                xDisabled={
                  HeadObject?.sLocation?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
 
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Report Type"} />
            </Grid>
            <Grid item xs={6} sm={6}  >
              <CmpRadioButton
                value="BINWISE_CBM"
                label="Binwise CBM"
                checked={HeadObject.sReportType === "BINWISE_CBM"}
                onChange={fReportType}
              />
            </Grid>
             
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
